const { createSelector } = require('reselect');

export const selectRoot = (state) => state.currentUser;

export const selectCurrentUser = createSelector(
	selectRoot,
	(data) => data.currentUser
);
